import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Select from "react-select";

import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import { useFormik, FormikProvider, FieldArray } from "formik";
import AWS from 'aws-sdk';
import { AWS_ACCESS_KEY_ID, AWS_SECRET_ACCESS_KEY, AWS_DEFAULT_REGION,AWS_BUCKET } from "../Global";
import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';
// import { toast } from "react-toastify";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {  Apitoken, Authtoken } from '../Global';
import $ from "jquery";
const QualityStockFollowUpEdit = () => {
  let { id } = useParams();
  const [menu, setMenu] = useState(false);
  const [value, setValue] = useState({});
  const [backendErrors, setBackendErrors] = useState([]);
  // const [backendSuccess, setBackendSuccess] = useState(null);
  const [statusOptions, setStatusOptions] = useState([]);
  const [locationLoading, setLocationLoading] = useState([]);
  const [permission, setPermission] = useState({});

 const [showTableHeadings, setShowTableHeadings] = useState(false);
  const [valueContents, setValueContents] = useState([]);
    let season_id = localStorage.getItem("season_id");

  useEffect(() => {
        setPermission(FindModuleById(455)); 
console.log(permission);

    axios
      .get(`/quality-stock-follow-ups/edit/${season_id+'-'+id}`, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        setValue(response.data.data.Stock);
        
        setValueContents(response.data.data.Stock.items);

      })
      .catch((error) => {
        console.log(error);
      });
  }, [id]);

  const formik = useFormik({
    initialValues: {
      id: value.id,
      date:value.date,
       season_id:season_id,
      
      location: value.location,
   
      
      contents: valueContents,
    },
    enableReinitialize: true,

    onSubmit:(values , { setSubmitting }) => {
      axios
        .post("/quality-stock-follow-ups/update", values, {
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        })
        .then((response) => {
          delete backendErrors['error'];
          setSubmitting(false);
          $("#form-submit").text("Update Stock Situation");
          if (response.data.code === 200) {
              toast.success(response.data.message);
            //actions.resetForm();
            setTimeout(() => {
              window.location.href = "/quality-stock-situations";
            }, 1000);
          }  else if (response.data.code === 422) {
              setBackendErrors(response.data.error);
          }
          else if (response.data.code === 401) {
            setBackendErrors(response.data.error);
          }
          else {
             setBackendErrors(response.data.error);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
  });

  const toggleMobileMenu = () => {
    setMenu(!menu);
  };

  const customHandleInput = (event) => {
    const Input_name = event.target.name;
    delete backendErrors[Input_name];
  };
  useEffect(() => {

    axios.post("/quality-consumables/listing",{}, {
      headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
    })
    .then((response) => {
      if(response.data.code === 200){
        let supplier_types = response.data.data.products;
       // setPackagingTypesLists(materials_payment_status);
        let supplier_typesList = supplier_types.map((ord, index) => ({
          label:  ord.consumable_name ,
          value: ord.id,
          key: `product-${index}`,
        }));
        setStatusOptions(supplier_typesList);
    }else{
        console.log("API response is not an array");
      }
              
    })
    .catch((error) => {
      console.log(error);
    });


    axios
    .get(`/helpers/loading-locations`, {
      headers: {
        Authorization: `Bearer ${Authtoken}`,
        Apitoken: Apitoken,
      },
    })
    .then((response) => {
      if (response.data.code === 200) {
        let locations = response.data.data.locations;
        let locationslisting = locations.map((ord, index) => ({
          label: ord.title,
          value: ord.id,
          key: `location-${index}`,
        }));
        setLocationLoading(locationslisting);
      } else {
        console.log("API response is not an array");
      }
    })
    .catch((error) => {
      console.log(error);
    });

}, []);

 

const operationArr =([
  { value: 'IN', label: "IN" },
  { value: 'OUT', label: "OUT" },
]);


  const viewFile =(link) =>{
    AWS.config.setPromisesDependency(); //use so you can promisify to get the actual images
    AWS.config.update({
    accessKeyId: AWS_ACCESS_KEY_ID,
    secretAccessKey: AWS_SECRET_ACCESS_KEY,
    region: AWS_DEFAULT_REGION,
    signatureVersion: 'v4',
    });
    const s3 = new AWS.S3();
    var params = {Bucket: AWS_BUCKET, Key: link};
    return  s3.getSignedUrl('getObject', params);
  }
 
  
const handleSelectChange = (name, selectedOption) => {
  const value = selectedOption ? selectedOption.value : "";
  updateFormikValue(name, value);
  customHandleInput({ target: { name, value } });
};

const updateFormikValue = (name, value) => {
  formik.setFieldValue(name, value);
};
  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar /><ToastContainer />
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <h3 className="page-title">Quality Stock Situation </h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/profile">Profile</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/quality-stock-situations">Quality Stock Situation</Link>
                    </li>
                    <li className="breadcrumb-item active">Edit</li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <h4 className="card-title">Quality Stock Situation </h4>
                    {permission && permission.update == 1 && (
                    <FormikProvider value={formik}>
                    <form action="#" onSubmit={formik.handleSubmit}>
                    <div className="row">
                    <div className="col-md-4 ">
                        
                        <div className="form-group status">
                       <label>Location</label>
                       {locationLoading.length > 0 && (
                         <Select
                         className="w-100"
                         value={locationLoading.find(option => option.value == formik.values.location) || null} // Ensure correct format
                         name="location"
                         onChange={(selectedOption) => {
                         handleSelectChange("location", selectedOption);
                      //   generateLotNumberLocation(selectedOption.value);
                         }}
                         onBlur={formik.handleBlur}
                         options={locationLoading}
                         placeholder="Select"
                         />
                       )}
                       <small>
                         {backendErrors.location && (
                             <span className="form-error mt-1">
                               {backendErrors.location}
                             </span>
                           )}
                       </small>
                     </div>
                     </div>
                     <div className="col-md-4 ">
                            <div className="form-group">
                              <label> Date</label>
                              <input
                                type="date"
                                name="date"
                                value={formik.values.date}
                                className="form-input form-control"
                                onChange={(e) => {
                                  formik.handleChange(e);
                                  customHandleInput(e);
                                }}
                                onBlur={formik.handleBlur}
                              />
                            <small>
                                {backendErrors.date  && (
                                  <span className="form-error mt-1">
                                    {backendErrors.date}
                                  </span>
                                )}
                              </small>
                            </div>
                        </div>
                   
                      </div>


                        
                 <div className="row">
                      <div className="col-md-6">
                        <h4 className="card-title">
                          <br />
                          Items
                        </h4>
                      </div>
                    </div>
                    <FieldArray
                      name="contents"
                      render={(arrayHelpers) => (
                        <div>
                          <button
                            className="btn btn-primary mb-3"
                            type="button"
                            onClick={() => {
                             
                                 let appendArr_1 = arrayHelpers.form.values.contents && arrayHelpers.form.values.contents[0];

                                    let operation = (appendArr_1 && appendArr_1.operation) ? appendArr_1.operation : "";
                                    let consomable = (appendArr_1 && appendArr_1.consomable) ? appendArr_1.consomable : "";
                                    let quantity = (appendArr_1 && appendArr_1.quantity) ? appendArr_1.quantity : "";
                                    let delivery_note = (appendArr_1 && appendArr_1.delivery_note) ? appendArr_1.delivery_note : "";
                                    let note = (appendArr_1 && appendArr_1.note) ? appendArr_1.note : "";
                                  
                                      let initialArr ={
                                      operation: operation,
                                      delivery_note_number:null,
                                      consomable: consomable,
                                      quantity: quantity,
                                      delivery_note: delivery_note,
                                      note: note,
                                    }
                                    arrayHelpers.push(initialArr);
                                   

                              // let initialArr ={
                              //   operation: "",
                              //   delivery_note_number: "",
                              //   consomable: "",
                              //   quantity:"",
                              //   delivery_note:"",
                              //   note:""
                              //     }
                              //  appendArr = (appendArr)?appendArr:initialArr;
                              //   if ("id" in appendArr) {
                              //     delete appendArr.id;
                              //   }
                              //  console.log(appendArr);
                              // arrayHelpers.push(appendArr);
                              setShowTableHeadings(true);
                             
                            }}
                          >
                            +
                          </button>

                            {showTableHeadings && (
                              <div className="row">
                             
                          </div>
                            )}
                            
                            {formik.values.contents.map(
                                (friend, index) => (
                                  <div  className="row" key={index}>
                                   
                                   <div  className="col-md-2">
                                      <div className="form-group status">
                                      <label> Operation</label><br/>
                                      {operationArr.length > 0 && (
                                        <Select
                                        name={`contents[${index}].operation`}
                                        options={operationArr}
                                        value={operationArr.find(option => option.value == formik.values.contents[index].operation) || null} // Ensure correct format
                                        onChange={(selectedOption) => {
                                          formik.setFieldValue(`contents[${index}].operation`, selectedOption.value); // ✅ Store only value in Formik
                                          customHandleInput({
                                            target: {
                                              name: `contents[${index}].operation`,
                                              value: selectedOption.value, // ✅ Ensure only value is passed
                                            },
                                          });
                                        }}
                                        onBlur={formik.handleBlur}
                                        placeholder="Select"
                                        className="w-100"
                                        />
                                      )}
                                       
                                      </div>
                                    </div>
                                    <div  className="col-md-2">
                                      <div className="form-group">
                                      <label>Quanity</label><br/>
                                        <input
                                           type="text"
                                           onKeyPress={(event) => {
                                             // Allow only numbers (0-9)
                                             if (!/^[0-9.]$/.test(event.key)) {
                                             event.preventDefault();
                                             }
                                           }}
                                          placeholder="Enter Quantity"
                                          className="form-input form-control"
                                          name={`contents[${index}].quantity`}
                                          value={
                                            formik.values.contents[index]
                                              .quantity
                                          }//onChange={formik.handleChange}
                                          onChange={(e) => {
                                            formik.handleChange(e);
                                            const newQuantity = parseFloat(e.target.value) || 0;
                                            const unitPrice = parseFloat(formik.values.contents[index].unit_price) || 0;
                                            formik.setFieldValue(`contents[${index}].total_amount`, newQuantity * unitPrice);
                                          }}
                                        />
                                      </div>
                                    </div>
                                    <div  className="col-md-2">
                                      <div className="form-group status">
                                      <label> Consumable</label><br/>
                                      {statusOptions.length > 0 && (
                                        <Select
                                        name={`contents[${index}].consomable`}
                                        options={statusOptions}
                                        value={statusOptions.find(option => option.value == formik.values.contents[index].consomable) || null} // Ensure correct format
                                        onChange={(selectedOption) => {
                                          formik.setFieldValue(`contents[${index}].consomable`, selectedOption.value); // ✅ Store only value in Formik
                                          customHandleInput({
                                            target: {
                                              name: `contents[${index}].consomable`,
                                              value: selectedOption.value, // ✅ Ensure only value is passed
                                            },
                                          });
                                        }}
                                        onBlur={formik.handleBlur}
                                        placeholder="Select"
                                        className="w-100"

                                        />
                                      )}
                                      
                                        
                                      </div>
                                    </div>
                                    

                                              <div  className="col-md-6">
                                                <div className="form-group">
                                                <label>Delivery Note Number</label><br/>
                                                
                                                  <input
                                                  type="text"
                                                  
                                                    placeholder="Delivery note Number"
                                                    className="form-input form-control"
                                                    name={`contents[${index}].delivery_note_number`}
                                                    value={
                                                      formik.values.contents[index]
                                                        .delivery_note_number
                                                    }
                                                    onChange={formik.handleChange}
                                                  />
                                                </div>
                                              </div>
                                     <div  className="col-md-6">
                                      <div className="form-group">
                                      <label>Note</label><br/>
                                        <input
                                          type="text"
                                          
                                          placeholder="Note"
                                          className="form-input form-control"
                                          name={`contents[${index}].note`}
                                          value={
                                            formik.values.contents[index]
                                              .note
                                          }
                                          onChange={formik.handleChange}
                                        />
                                      </div>
                                    </div>

                                    <div  className="col-md-5">
                                    <div className="form-group " >
                                      <label>Delivery Note</label><br/>
                                      <input
                                      className="form-group"
                                      type="file"
                                      name={`contents[${index}].delivery_note`}
                                      id={`fileupload-${index}`}

                                      onChange={(event) => {
                                        //getFileData(event);

                                        const file_link = event.target.files[0];
                                        //console.log("file:", file_link);
                                        //const fileName = file_link.name;
                                        //const fileName = file_link.name;
                                        const reader = new FileReader();

                                        reader.onloadend = () => {
                                          formik.setFieldValue(
                                            `contents[${index}].delivery_note`,
                                            reader.result
                                          );
                                        };
      
                                        if (file_link) {
                                          reader.readAsDataURL(file_link);
                                        }
                                      }}
                                    />
                                    {formik.values.contents[index].delivery_note &&
                                      typeof formik.values.contents[index].delivery_note === 'string' &&
                                      !formik.values.contents[index].delivery_note.startsWith('data:') && (
                                        <a
                                          className="btn btn-link"
                                          href={viewFile(formik.values.contents[index].delivery_note)}
                                          target="_blank"
                                          rel="noreferrer"
                                          download
                                        >
                                          Download
                                        </a>
                                    )}

                                      </div>
                                    </div>
                                   
                                   
                                   
                                   
                                    <div  className="col-md-1">
                                      <div className="form-group">
                                        <button
                                          className="btn btn-danger"
                                           style={{ marginTop: 30 }}
                                          type="button"
                                          onClick={() =>
                                            arrayHelpers.remove(index)
                                          }
                                        >
                                          -
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                )
                              )}
                           
                        </div>
                      )}
                    />
                      <small>
                              {backendErrors.status  && (
                                <span className="form-error mt-1">
                                  {backendErrors.status}
                                </span>
                              )}
                            </small>
                      
                      <div className="text-end mt-4">
                          <button
                            type="submit" id="form-submit"
                            className="btn btn-primary"
                            disabled={formik.isSubmitting}
                          >
                            Update Quality Stock Situation
                          </button>
                        </div>
                    </form>
                  </FormikProvider>
              )}
                   
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default QualityStockFollowUpEdit;
